/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Url_TakenInputs */



/**
* | output |
* | --- |
* | "You already have a link to this address — edit that one instead" |
*
* @param {Community_Link_Url_TakenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_url_taken = /** @type {((inputs?: Community_Link_Url_TakenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Url_TakenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez déjà un lien vers cette adresse — modifiez plutôt celui-ci")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ya tienes un enlace a esta dirección; edita ese en su lugar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você já tem um link para este endereço — edite esse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai già un link a questo indirizzo: modifica quello")
	return /** @type {LocalizedString} */ ("You already have a link to this address — edit that one instead")
});